<template>
  <div>
		<div class="actTop_info">
      <div class="actTop_infoText" v-text="actTime"></div>
      <div class="actTop_infoText" v-if="isLogin">
        <div>
          您好，
          <span class="actTop_name">{{nickName}}</span>
					<span class="actTop_name">{{bindPartitionName}}</span>
					<span class="actTop_name">{{bindRoleName}}</span>
        </div>
        <div class="actTop_InfoUser">
          <a href="javascript:;" v-if="bindRole === '1'" class="actTop_InfoLink" @click="areaIsShow()">{{area.optTitle}}</a>
          <a href="javascript:;" v-if="personMsg === '1'" class="actTop_InfoLink" @click="infoIsShow()">个人信息</a>
          <a href="javascript:;" v-if="record === '1'" class="actTop_InfoLink" @click="recordIsShow()">领奖记录</a>
        </div>
      </div>
      <div class="actTop_infoText" v-else>
        您好，请
        <span v-if="(loginType === '1' || loginType ==='2') && !isLogin"><a href="javascript:;" class="actTop_login" @click="qcLogin()">【QQ登录】</a>或</span>
        <a v-if="(loginType === '1' || loginType ==='3') && !isLogin" href="javascript:;" class="actTop_login" @click="wxLogin()">【微信登录】</a>
      </div>
    </div>
		<!-- 弹窗开始-->
    <div class="actModal" v-if="areaModal">
      <div class="actModal_content">
        <a href="javascript:;" class="actModal_closeBtn" @click="areaModalClose()">
          <span></span>
        </a>
        <div class="actModal_header">
          <h3 v-text="area.title"></h3>
        </div>
        <div>
          <ul>
            <li class="actModal_li">
              <select @change="queryRole()" id="partition" v-model="partitionId">
								<option
									v-for="(area,index) in area.content"
									:key="index"
									:value="area.value"
									v-text="area.name"
								></option>
              </select>
            </li>
            <li class="actModal_li">
              <select id="role" v-model="roleId">
                <option
                  v-for="(job,index) in jobs.content"
                  :key="index"
                  :value="job.roleId"
                  v-text="job.roleName"
                ></option>
              </select>
            </li>
          </ul>
        </div>
        <div class="actModal_footer">
          <a href="javascript:;" @click="subBindRole()" class="actModal_footerBtn">绑定大区</a>
        </div>
      </div>
    </div>
    <!-- 弹窗结束-->
		<!-- 弹窗开始-->
    <div class="actModal" v-if="areaModalPC">
      <div class="actModal_content">
        <a href="javascript:;" class="actModal_closeBtn" @click="areaModalClose()">
          <span></span>
        </a>
        <div class="actModal_header">
          <h3 v-text="area.title"></h3>
        </div>
        <div>
          <ul>
            <li class="actModal_li">
              <select @change="showSenPar()" id="PCpartition">
								<option
									v-for="(area,index) in area.content"
									:key="index"
									:value="area.value"
									v-text="area.name"
								></option>
              </select>
            </li>
						<li class="actModal_li" @change="queryRole()" id="PCSenPartition" v-if="area.secondPar">
              <select v-model="partitionId">
								<option
									v-for="(area,index) in area.secondPar"
									:key="index"
									:value="area.value"
									v-text="area.name"
								></option>
              </select>
            </li>
            <li class="actModal_li">
              <select id="role" v-model="roleId">
                <option
                  v-for="(job,index) in jobs.content"
                  :key="index"
                  :value="job.roleId"
                  v-text="job.roleName"
                ></option>
              </select>
            </li>
          </ul>
        </div>
        <div class="actModal_footer">
          <a href="javascript:;" @click="subBindRole()" class="actModal_footerBtn">绑定大区</a>
        </div>
      </div>
    </div>
    <!-- 弹窗结束-->
		<!-- 弹窗开始-->
    <div class="actModal" v-if="infoModal">
      <div class="actModal_content">
        <a href="javascript:;" class="actModal_closeBtn" @click="infoModalClose()">
          <span></span>
        </a>
        <div class="actModal_header">
          <h3 v-text="info.title"></h3>
        </div>
        <div>
          <div class="actModal_bodyTitle" v-text="info.content"></div>
        </div>
      </div>
    </div>
    <!-- 弹窗结束-->
		<!-- 弹窗开始-->
    <div class="actModal" v-if="recordModal">
      <div class="actModal_content">
        <a href="javascript:;" class="actModal_closeBtn" @click="recodeModalClose()">
          <span></span>
        </a>
        <div class="actModal_header">
          <h3 v-text="awards.title"></h3>
        </div>
        <div>
          <div class="actModal_awardsList">
            <table>
              <thead>
                <tr>
                  <td width="140">道具名称</td>
                  <td width="200">领取时间</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(awards,index) in awards.content" :key="index">
                  <td v-text="awards.name"></td>
                  <td v-text="awards.time"></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="actModal_awardsPages">
            <a href="javascript:;" class="actModal_awardsPagesBtn">上一页</a>
            <input placeholder class="actModal_awardsPagesInput">
            <a href="javascript:;" class="actModal_awardsPagesBtn">下一页</a>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹窗结束-->
	</div>
</template>
<script>
import './../../assets/css/reset.css'
import bus from '../../../bus'
export default {
	name: 'pc-signIn',
	actConfig: {
		labels: { // 字段名称，用于显示在配置系统上，在正式环境会删除
			loginType: '登陆方式',
			bindRole: '是否绑定大区',
			personMsg: '是否展示个人信息',
			record: '是否展示领奖记录',
			actTime: '活动时间',
			queryRoleFlowId: '查询角色流程id',
			bindRoleFlowId: '绑定角色流程id',
			queryHistoryRoleFlowId: '查询历史角色绑定记录',
			giftRecordFlowId: '获奖记录流程id',
			gitfIsGeted: '礼包领取状态流程id',
		},
	},
	props: {
		loginType: {
			type: String,
			default: '1' // 登陆类型：1表示QQ+微信登陆，2表示QQ登陆，3表示微信登陆，4表示不登陆
		},
		bindRole: {
			type: String,
			default: '1' // 绑定大区：1表示有绑定大区操作，0表示不绑定大区
		},
		personMsg: {
			type: String,
			default: '0' // 个人信息：1表示有绑定个人信息操作，0表示不展示个人信息
		},
		record: {
			type: String,
			default: '1' // 领奖记录：1表示有领奖记录操作，0表示展示领奖记录
		},
		actTime: {
			type: String,
			default: ''
		},
		queryRoleFlowId: {
			type: Array,
			default: function () {
				return [
					{
						action: {
							class: 'action',
							title: '查询角色流程id',
							value: ''
						}
					}
				]
			}
		},
		bindRoleFlowId: {
			type: Array,
			default: function () {
				return [
					{
						action: {
							class: 'action',
							title: '绑定角色流程id',
							value: ''
						}
					}
				]
			}
		},
		queryHistoryRoleFlowId: {
			type: Array,
			default: function () {
				return [
					{
						action: {
							class: 'action',
							title: '查询历史角色绑定记录',
							value: ''
						}
					}
				]
			}
		},
		giftRecordFlowId: {
			type: Array,
			default: function () {
				return [
					{
						action: {
							class: 'action',
							title: '获奖记录流程id',
							value: ''
						}
					}
				]
			}
		},
		gitfIsGeted: {
			type: Array,
			default: function () {
				return [
					{
						action: {
							class: 'action',
							title: '礼包领取记录流程id',
							value: ''
						}
					}
				]
			}
		}
	},
	data () {
		return {
			isLogin: false,
			areaModal: false,
			jsBindIsLoad: false,
			area: {
				optTitle: '绑定大区',
				title: '绑定大区',
				content: null,
				secondPar: null
			},
			jobs: {
				title: '',
				content: []
			},
			areaModalPC: false,
			infoModal: false,
			info: {
				title: '个人信息',
				content: '自定义自定义自定义自定义自定自定义自定义自定义自定义自定自定义自定义自定义自定义自定自定义自定义自定义自定义自定'
			},
			recordModal: false,
			awards: {
				title: '领奖记录',
				content: []
			},
			loginInfo: {},
			nickName: null,
			partitionName: null,
			roleName: null,
			isIos: false,
			isAndroid: false,
			partitionId: 0, // 小区id
			roleId: 0, // 角色id
			sArea: 1, // 微信账号为1，QQ账号为2
			sPlatId: 0, // 平台编号：ios是0，安卓是1
			sAreaName: '', // 区服名称
			sRoleName: '', // 角色名称
			bindRoleId: 0, // 已经绑定的角色id
			bindRoleName: '', // 已经绑定的角色名
			bindPartitionId: 0, // 已经绑定的大区id
			bindPartitionName: '', // 已经绑定的大区名
		}
	},
	mounted () {
		// if (window._Vue.$actMode !== 'production') {
		// 	return
		// }
		this.$actConfig.gameCode = this.$actConfig.gameCode
		this.init_login()
		this.isIos = /ipad|iphone|ipod/ig.test(navigator.userAgent.toLowerCase())
		this.isAndroid = /linux|android/ig.test(navigator.userAgent.toLowerCase())
	},
	updated () {
	},
	methods: {
		init_login () {
			let _self = this
			_self.$miloLogin().then(LoginManager => {
				let isApp = /tgclub/ig.test(navigator.userAgent.toLowerCase())
				let loginConfig = _self.getLoginConfig()
				if (isApp && window.milo.cookie.get('acctype') !== 'qc') {
					window.iUseQQConnect = 0
				} else {
					window.iUseQQConnect = 1
				}
				if (typeof (LoginManager.init) === 'undefined') {
					return
				}
				if (!isApp) {
					LoginManager.init(loginConfig)
				}
				LoginManager.checkLogin((userInfo) => {
					_self.isLogin = true
					this.loginInfo = userInfo
					let gCodeSeverselectUrl = '//xinyue.qq.com/act/vipmb_new/gCodeSeverselect_v1.js'
					this.loadScript(gCodeSeverselectUrl, () => {
						if (typeof (window['gCodeServerselect'][this.$actConfig.gameCode]) !== 'undefined') {
							if (window['gCodeServerselect'][this.$actConfig.gameCode]['type'] === 1 && window['gCodeServerselect'][this.$actConfig.gameCode]['partition'] === 0) {
								this.queryRole()
							}
						}
					})
					this.queryBind()
					this.gitfIsGeted[0].action.value = 561372
					this.$doAction('ame', this.gitfIsGeted[0].action.value).then(({res}) => {
						console.log(res)
						if (res.iRet === '0') {
							console.log(res.sOutValue1)
							let holdQualiArr = res.sOutValue1.split('|')
							for (let keyi = 0; keyi < holdQualiArr.length; keyi++) {
								let singleArr = holdQualiArr[keyi].split(' ')
								if (typeof (this.isGeted.h5['h' + singleArr[0]]) === 'undefined') {
									this.isGeted.h5['h' + singleArr[0]] = []
								}
								this.isGeted.h5['h' + singleArr[0]][0] = singleArr[1]
								this.isGeted.h5['h' + singleArr[0]][1] = singleArr[2]
							}
							bus.$emit('giftReceivedStatus', this.isGeted.h5)
							console.log(this.isGeted.h5)
						} else {
							alert(res.sMsg)
						}
					}).catch((e) => {
						console.log(e)
						alert(e.sMsg)
					})
					// 这里做登陆后的业务逻辑处理
					if (typeof (this.loginInfo.loginType) !== 'undefined' && this.loginInfo.loginType === 'wx') {
						let wxNickName = LoginManager.getWxNickName()
						this.nickName = wxNickName
					} else {
						let qqNickName = LoginManager.getNickName()
						this.nickName = qqNickName
					}
				}, () => {
					console.log('未登录')
				})
			})
		},
		qcLogin () {
			// if (window._Vue.$actMode !== 'production') {
			// 	return
			// }
			this.$miloLogin().then(LoginManager => {
				LoginManager.login({
					iUseQQConnect: 1
				});
			})
		},
		wxLogin () {
			// if (window._Vue.$actMode !== 'production') {
			// 	return
			// }
			let loginConfig = this.getLoginConfig()
			this.$miloLogin().then(LoginManager => {
				LoginManager.loginByWX(loginConfig);
			})
		},
		quit () {
			this.$miloLogin().then(LoginManager => {
				LoginManager.logout(() => {
					window.reload()
				})
			})
		},
		// 展示绑定大区
		areaIsShow () {
			this.recordModal = false
			this.infoModal = false
			if (!this.isLogin) {
				alert('请先登陆')
				return
			}
			if (!this.jsBindIsLoad) {
				let loadUrl = `//gameact.qq.com/comm-htdocs/js/game_area/${this.$actConfig.gameCode}_server_select.js`
				this.loadScript(loadUrl, () => {
					this.showPartitionList()
					this.jsBindIsLoad = true
				})
			}
			if (window['gCodeServerselect'][this.$actConfig.gameCode]['type'] === 2 && window['gCodeServerselect'][this.$actConfig.gameCode]['partition'] === 1) {
				this.areaModalPC = true
			} else {
				this.areaModal = true
			}
		},
		// 关闭绑定大区
		areaModalClose () {
			this.areaModal = false
			this.areaModalPC = false
		},
		// 展示个人信息
		infoIsShow () {
			this.areaModal = false
			this.recordModal = false
			this.areaModalPC = false
			this.infoModal = true
		},
		// 关闭个人信息
		infoModalClose () {
			this.infoModal = false
		},
		// 展示获奖记录
		recordIsShow (PageNow = 0) {
			this.areaModal = false
			this.infoModal = false
			this.areaModalPC = false
			this.recordModal = true
			let iPageNow = PageNow > 0 ? PageNow : 1
			this.$doAction('record', this.giftRecordFlowId[0].action.value, {iPageSize: 6, iPageNow: iPageNow}).then(({list, allData}) => {
				this.awards.content = []
				for (let i = 0; i < list.length; i++) {
					let singleGift = {name: list[i].sPackageName, time: list[i].dtGetPackageTime}
					this.awards.content.push(singleGift)
				}
			}).catch((e) => {
				console.log(e)
				alert(e.sMsg)
			})
		},
		// 关闭获奖记录
		recodeModalClose () {
			this.recordModal = false
		},
		// 加载js方法
		loadScript (url, callback) {
			let headA = document.getElementsByTagName('head')[0]
			let scriptTag = document.createElement('script')
			scriptTag.type = 'text/javascript'
			scriptTag.src = url
			scriptTag.charset = 'gbk'
			headA.appendChild(scriptTag)
			scriptTag.onload = () => {
				if (typeof (callback) === 'function') {
					callback()
				}
			}
		},
		// 查询角色
		queryRole () {
			if (window['gCodeServerselect'][this.$actConfig.gameCode]['type'] === 1 && window['gCodeServerselect'][this.$actConfig.gameCode]['partition'] === 1) {
				if (this.loginInfo.loginType === 'wx') {
					this.sArea = 1
				} else {
					this.sArea = 2
				}
				if (this.isIos) {
					this.sPlatId = 0
				} else {
					this.sPlatId = 1
				}
				this.$doAction('ame', this.queryRoleFlowId[0].action.value, {sArea: this.sArea, sPlatId: this.sPlatId, sPartition: this.partitionId}).then(({jData, ...other}) => {
					if (typeof (jData.list) !== 'undefined') {
						let roleList = jData.list
						this.jobs.content = []
						if (roleList && roleList.length) {
							for (let i = 0; i < roleList.length; i++) {
								let singleRole = {roleId: roleList[i].roleid, roleName: decodeURIComponent(roleList[i].rolename)}
								this.jobs.content.push(singleRole)
							}
						} else {
							let singleRole = {roleId: '', roleName: '该服务器无角色'}
							this.jobs.content.push(singleRole)
						}
					}
				}).catch((e) => {
					console.log(e)
					this.jobs.content = []
					let singleRole = {roleId: '', roleName: '该服务器无角色'}
					this.jobs.content.push(singleRole)
				})
			}
		},
		// 区服信息
		showPartitionList () {
			this.area.content = []
			let nonePar = {name: '请选择大区', value: ''}
			this.area.content.push(nonePar)
			if (window.gCodeServerselect[this.$actConfig.gameCode].type === 1) { // 手游有小区，角色
				if (!window.gCodeServerselect[this.$actConfig.gameCode].partition) return 0
				if (!this.isIos && !this.isAndroid) {
					return 0
				}
				let ck = this.loginInfo.loginType === 'wx' ? 'weixin' : 'qq'
				let sk = ''
				if (this.isIos) {
					sk = 'ios'
				} else if (this.isAndroid) {
					sk = 'android'
				}
				let arrOpt = window[window.gCodeServerselect[this.$actConfig.gameCode].selectCode + 'ServerSelect'].STD_DATA
				console.log(arrOpt)
				if (arrOpt) {
					for (let i = 0; i < arrOpt.length; i++) {
						if (arrOpt[i].sk !== sk || arrOpt[i].ck !== ck) continue
						if (parseInt(arrOpt[i].status) !== 0) {
							let singlePar = {name: arrOpt[i].t, value: arrOpt[i].v}
							this.area.content.push(singlePar)
						}
					}
				}
			} else if (window.gCodeServerselect[this.$actConfig.gameCode].type === 2 && window.gCodeServerselect[this.$actConfig.gameCode].partition === 0) { // 端游有大区，有角色
				if (window[window.gCodeServerselect[this.$actConfig.gameCode].selectCode + 'ServerSelect'].STD_DATA) {
					let arrOpt = window[window.gCodeServerselect[this.$actConfig.gameCode].selectCode + 'ServerSelect'].STD_DATA
					for (let i = 0; i < arrOpt.length; i++) {
						if (parseInt(arrOpt[i].status) !== 0) {
							let singlePar = {name: arrOpt[i].t, value: arrOpt[i].v}
							this.area.content.push(singlePar)
						}
					}
				}
			} else if (window.gCodeServerselect[this.$actConfig.gameCode].type === 2 && window.gCodeServerselect[this.$actConfig.gameCode].partition === 1) { // 端游有大区有小区，有角色
				if (window[window.gCodeServerselect[this.$actConfig.gameCode].selectCode + 'ServerSelect'].STD_DATA) {
					let arrOpt = window[window.gCodeServerselect[this.$actConfig.gameCode].selectCode + 'ServerSelect'].STD_DATA
					for (let i = 0; i < arrOpt.length; i++) {
						let nonePar = {name: '请选择小区', value: ''}
						this.area.content.push(nonePar)
						let daQuIndex = document.getElementById('PCpartition').selectedIndex
						let daQuValue = document.getElementById('PCpartition').options[daQuIndex].value
						if (daQuValue === arrOpt[i].v) {
							for (let j = 0; j < arrOpt[i].opt_data_array.length; j++) {
								let singlePar = {name: arrOpt[i].opt_data_array[j].t, value: arrOpt[i].opt_data_array[j].v}
								this.area.content.push(singlePar)
							}
							break
						}
					}
				}
			}
		},
		// 端游获取小区
		showSenPar () {
			if (window[window.gCodeServerselect[this.$actConfig.gameCode].selectCode + 'ServerSelect'].STD_DATA) {
				let arrOpt = window[window.gCodeServerselect[this.$actConfig.gameCode].selectCode + 'ServerSelect'].STD_DATA
				for (let i = 0; i < arrOpt.length; i++) {
					this.area.secondPar = []
					let singlePar = {name: arrOpt[i].t, value: arrOpt[i].v}
					this.area.secondPar.push(singlePar)
				}
			}
		},
		// 提交大区绑定
		subBindRole () {
			if (this.roleId && this.partitionId) {
				if (window.gCodeServerselect[this.$actConfig.gameCode].type === 1) { // 手游有小区与角色
					if (this.loginInfo.loginType === 'wx') {
						this.sArea = 1
					} else {
						this.sArea = 2
					}
					if (this.isIos) {
						this.sPlatId = 0
					} else {
						this.sPlatId = 1
					}
					let sAreaIndex = document.getElementById('partition').selectedIndex
					this.sAreaName = document.getElementById('partition').options[sAreaIndex].text
					let sRoleIndex = document.getElementById('role').selectedIndex
					this.sRoleName = document.getElementById('role').options[sRoleIndex].text
					this.$doAction('ame', this.bindRoleFlowId[0].action.value, {sArea: this.sArea, sPartition: this.partitionId, sPlatId: this.sPlatId, sRoleId: this.roleId, sAreaName: this.sAreaName, sRoleName: this.sRoleName}).then(({jData, ...other}) => {
						if (jData.result === 0) {
							let roleMsg = JSON.parse(jData.bind_info)
							this.bindRoleId = roleMsg.sRoleId
							this.bindRoleName = decodeURIComponent(roleMsg.sRoleName)
							this.bindPartitionId = roleMsg.sPartition
							this.bindPartitionName = decodeURIComponent(roleMsg.sAreaName)
							alert('绑定成功')
							this.areaModal = false
							this.areaModalPC = false
							this.area.optTitle = '更改绑定'
							if (!window.bindInfo) {
								window.bindInfo = {}
							}
							window.bindInfo.sArea = roleMsg.sArea
							window.bindInfo.sPlatId = roleMsg.sPlatId
							window.bindInfo.sPartition = roleMsg.sPartition
							window.bindInfo.sRoleId = roleMsg.sRoleId
						}
					}).catch((e) => {
						console.log(e)
						alert(e.sMsg)
					})
				} else if (window.gCodeServerselect[this.$actConfig.gameCode].type === 2 && window.gCodeServerselect[this.$actConfig.gameCode].partition === 0) { // 端游有大区角色

				} else if (window.gCodeServerselect[this.$actConfig.gameCode].type === 2 && window.gCodeServerselect[this.$actConfig.gameCode].partition === 1) { // 端游有大区有小区角色

				}
			}
		},
		// 查询
		queryBind () {
			this.$doAction('ame', this.queryHistoryRoleFlowId[0].action.value).then(({jData, ...other}) => {
				if (jData.result === 0) {
					let roleMsg = JSON.parse(jData.bind_info)
					this.bindRoleId = roleMsg.sRoleId
					this.bindRoleName = decodeURIComponent(roleMsg.sRoleName)
					this.bindPartitionId = roleMsg.sPartition
					this.bindPartitionName = decodeURIComponent(roleMsg.sAreaName)
					this.areaModal = false
					this.areaModalPC = false
					this.area.optTitle = '更改绑定'
					if (!window.bindInfo) {
						window.bindInfo = {}
					}
					window.bindInfo.sArea = roleMsg.sArea
					window.bindInfo.sPlatId = roleMsg.sPlatId
					window.bindInfo.sPartition = roleMsg.sPartition
					window.bindInfo.sRoleId = roleMsg.sRoleId
				}
			}).catch((e) => {
				console.log(e)
				alert(e.sMsg)
			})
		},
		getLoginConfig () {
			let loginConfig = {}
			let isMobile = /ipad|iphone|ipod|linux|android/ig.test(navigator.userAgent.toLowerCase())
			if (isMobile) {
				loginConfig = {
					appConfig: {
						'QQBrowserAppId': '106', // 在QQ浏览器端申请的APPID，保持不变
						'WxAppId': 'wx5a3bbeac0d87c75a', // 需要在微信申请openLink权限，
						'AppName': '心悦俱乐部', // 业务的中文名称
						'scope': 'snsapi_userinfo', // 默认是 snsapi_base 静默授权，如果游戏无静默权限，就需要手动改成 snsapi_userinfo
						'LogoUrl': 'http://ossweb-img.qq.com/images/feiji/web201507/logo.png' // 业务在授权时需要显示的正方形标准Logo，
					},
					userinfoSpan: 'userinfo'
				}
			} else {
				loginConfig = {
					onnectParams: {
						appId: '101478665',
						redirect_uri: document.location.protocol + '//xinyue.qq.com/comm-htdocs/login/qc_redirect.html'
					},
					iUseQQConnect: 1
				}
			}
			return loginConfig
		}
	},
}
</script>
<style scoped lang="scss">
	@import "../../assets/scss/common.scss";
	.actTop_info {
		margin-top: 40px;
	}
	.actTop_infoText {
		font-size: 24px;
		color: #4a4a4a;
		text-align: center;
		& + .actTop_infoText {
			margin-top: 15px;
		}
	}
	.actTop_login {
		text-decoration: none;
		color: #4a4a4a;
	}
	.actTop_InfoUser {
		font-size: 0;
		text-align: center;
		margin-top: 62px;
	}
	.actTop_InfoLink {
		font-size: 24px;
		color: #4a4a4a;
		margin: 0 53px;
	}
</style>



// WEBPACK FOOTER //
// src/components/actModules/pc/templates/signIn/signin.vue